import React from "react";
import ICON from "../icons.js";
import HomeImage from "./HomeImage.js";
import { stripJuristic } from "../../../components/text-sanitize.js";
import { telUrl } from "../../../components/sale-format.js";

// กดการ์ดด้วยคีย์บอร์ด (Enter/Space) ได้เหมือนคลิก — เฉพาะตอนโฟกัสอยู่ที่ตัวการ์ด ไม่ใช่ปุ่มโทรข้างใน
const onCardKey = (event, open) => {
    if (event.target !== event.currentTarget) return;
    if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        open();
    }
};

/* ============================================================================
 * HomeProjects — โครงการที่มีห้องประกาศ + กล่องรีวิวผู้อยู่อาศัยด้านขวา
 *
 * 2 คอลัมน์ : เลือกจากโครงการที่รู้จัก (ซ้าย) หรืออ่านเสียงจากคนที่อยู่จริง (ขวา)
 * ผู้ใช้จะได้ทั้งทางเลือกและความมั่นใจในสายตาเดียว
 *
 * ★ รูป/ชื่อ/ที่อยู่/เบอร์ของการ์ด มาจากหน้า "การตั้งค่าการขาย (โครงการ) > ข้อมูลบริษัท" (card_*)
 *   backend เติมข้อมูลโครงการให้แล้วถ้าช่องนั้นยังว่าง — ที่นี่ fallback ไว้กัน backend รุ่นเก่า
 * ========================================================================== */
export default function HomeProjects({ items = [], testimonials = [], onOpen }) {
    if (!items.length) return null;

    return (
        <section className="hm-section" id="hm-projects">
            <div className="hm-container">
                <div className="hm-split">
                    <div className="hm-split__main">
                        <div className="hm-section__head">
                            <h2 className="hm-section__title">โครงการที่มีห้องประกาศ</h2>
                        </div>

                        <div className="hm-grid">
                            {items.map((item) => {
                                const name = stripJuristic(item.card_name || item.project_name);
                                const phone = item.card_phone || item.phone_number;
                                const open = () => onOpen && onOpen(item);
                                return (
                                <article
                                    key={item.project_id}
                                    className="hm-card hm-card--project"
                                    role="button"
                                    tabIndex={0}
                                    aria-label={`ดูห้องประกาศของ ${name}`}
                                    onClick={open}
                                    onKeyDown={(e) => onCardKey(e, open)}
                                >
                                    <div className="hm-card__media">
                                        <HomeImage src={item.picture} alt={name} icon={ICON.building} />
                                        <div className="hm-card__badges">
                                            <span className="hm-badge hm-badge--green">{item.listing_count} ห้อง</span>
                                        </div>
                                    </div>
                                    <div className="hm-card__body">
                                        <h3 className="hm-card__title">{name}</h3>
                                        <div className="hm-card__loc">{item.card_address || item.address_detail || ""}</div>
                                        {/* ★ เบอร์โครงการเป็นปุ่มกดโทรได้เลย (เดิมเป็นข้อความเฉย ๆ ตัวใหญ่เท่าราคา
                                            ทำให้การ์ดโครงการดูแข่งกับการ์ดห้อง ทั้งที่คนละความสำคัญ) */}
                                        {!!telUrl(phone) && (
                                            <a
                                                className="hm-btn hm-btn--ghost hm-btn--sm w-100 mt-2"
                                                href={telUrl(phone)}
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <span className="hm-ico">{ICON.phone}</span> {phone}
                                            </a>
                                        )}
                                    </div>
                                </article>
                                );
                            })}
                        </div>
                    </div>

                    {!!testimonials.length && (
                        <aside className="hm-split__side">
                            <div className="hm-section__head">
                                <h2 className="hm-section__title">เสียงจากผู้อยู่อาศัย</h2>
                            </div>
                            <div className="hm-lifes">
                                {testimonials.map((item) => (
                                    <div key={item.uid} className="hm-life" style={{ display: "block", textAlign: "left" }}>
                                        <p className="hm-muted mb-2">{item.body}</p>
                                        <div className="hm-life__label">{item.title}</div>
                                        <small className="hm-muted">{item.subtitle}</small>
                                    </div>
                                ))}
                            </div>
                        </aside>
                    )}
                </div>
            </div>
        </section>
    );
}
